import React, { useState, useEffect } from 'react';
import { 
  Card, Form, Input, Button, message, Typography, Space, 
  Divider, Switch, InputNumber, Row, Col 
} from 'antd';
import { SaveOutlined, ReloadOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const AdminSettings = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    setLoading(true);
    try {
      // 这里可以从后端加载系统设置
      // 暂时使用默认值
      form.setFieldsValue({
        system_name: '亚马逊AI产品管理系统',
        max_upload_size: 100,
        session_timeout: 30,
        enable_registration: true,
        enable_email_notification: false,
        ai_request_limit: 1000,
        data_retention_days: 30
      });
    } catch (error) {
      message.error('加载设置失败');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (values) => {
    setSaveLoading(true);
    try {
      // 这里可以保存设置到后端
      console.log('保存设置:', values);
      
      // 模拟保存延迟
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      message.success('设置保存成功');
    } catch (error) {
      message.error('保存设置失败');
    } finally {
      setSaveLoading(false);
    }
  };

  return (
    <div style={{ padding: '24px' }}>
      <Card>
        <Title level={4}>系统设置</Title>
        <Text type="secondary">配置系统的基本参数和功能开关</Text>
        
        <Divider />
        
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSave}
          loading={loading}
        >
          <Row gutter={24}>
            <Col span={12}>
              <Card title="基本设置" size="small" style={{ marginBottom: 16 }}>
                <Form.Item
                  name="system_name"
                  label="系统名称"
                  rules={[{ required: true, message: '请输入系统名称' }]}
                >
                  <Input placeholder="请输入系统名称" />
                </Form.Item>

                <Form.Item
                  name="max_upload_size"
                  label="最大上传文件大小 (MB)"
                  rules={[{ required: true, message: '请输入最大上传文件大小' }]}
                >
                  <InputNumber 
                    min={1} 
                    max={1000} 
                    style={{ width: '100%' }}
                    placeholder="请输入最大上传文件大小"
                  />
                </Form.Item>

                <Form.Item
                  name="session_timeout"
                  label="会话超时时间 (分钟)"
                  rules={[{ required: true, message: '请输入会话超时时间' }]}
                >
                  <InputNumber 
                    min={5} 
                    max={1440} 
                    style={{ width: '100%' }}
                    placeholder="请输入会话超时时间"
                  />
                </Form.Item>
              </Card>
            </Col>

            <Col span={12}>
              <Card title="功能开关" size="small" style={{ marginBottom: 16 }}>
                <Form.Item
                  name="enable_registration"
                  label="允许用户注册"
                  valuePropName="checked"
                >
                  <Switch />
                </Form.Item>

                <Form.Item
                  name="enable_email_notification"
                  label="启用邮件通知"
                  valuePropName="checked"
                >
                  <Switch />
                </Form.Item>

                <Form.Item
                  name="ai_request_limit"
                  label="AI请求限制 (每日)"
                  rules={[{ required: true, message: '请输入AI请求限制' }]}
                >
                  <InputNumber 
                    min={100} 
                    max={10000} 
                    style={{ width: '100%' }}
                    placeholder="请输入AI请求限制"
                  />
                </Form.Item>

                <Form.Item
                  name="data_retention_days"
                  label="数据保留天数"
                  rules={[{ required: true, message: '请输入数据保留天数' }]}
                >
                  <InputNumber 
                    min={7} 
                    max={365} 
                    style={{ width: '100%' }}
                    placeholder="请输入数据保留天数"
                  />
                </Form.Item>
              </Card>
            </Col>
          </Row>

          <Divider />

          <Form.Item>
            <Space>
              <Button 
                type="primary" 
                htmlType="submit" 
                loading={saveLoading}
                icon={<SaveOutlined />}
              >
                保存设置
              </Button>
              <Button 
                onClick={loadSettings}
                loading={loading}
                icon={<ReloadOutlined />}
              >
                重置
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default AdminSettings;